import React, { MouseEventHandler, MouseEvent } from 'react';
import { Menu, MenuItem } from '@mui/material';


export type SimpleMenuProps<T> = {
  onChange(item: T): void;
  options: T[];
  valueKey: keyof T;
  labelKey: keyof T;
  value?: T;
  button: (opts: { onClick: MouseEventHandler<HTMLElement> }) => React.ReactElement;
};


export function SimpleMenu<T extends Record<string, any>>(props: SimpleMenuProps<T>): React.ReactElement {
  const [ anchorEl, setAnchorEl ] = React.useState<HTMLElement>();

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (item: T) => {
    props.onChange?.(item);
    setAnchorEl(undefined);
  };

  const handleClose = () => {
    setAnchorEl(undefined);
  };

  return (
    <>
      {props.button({ onClick: handleOpenMenu })}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {props.options.map((option, index) => (
          <MenuItem
            key={option[props.valueKey] ?? index}
            selected={option[props.valueKey] === props.value?.[props.valueKey]}
            disabled={option.disabled}
            onClick={() => handleMenuItemClick(option)}
          >
            {option[props.labelKey]}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
